import React, { useCallback, Fragment } from 'react'
import { AnyAction } from 'redux'

import { Typography, Card, CardContent, makeStyles, ListItemSecondaryAction } from '@material-ui/core'
import { List, ListItem, ListItemText } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'

import moment from 'moment' 
import {useDropzone} from 'react-dropzone'
import ReactDOM from 'react-dom'
import ReactPlayer from 'react-player'

import { AppState } from '../store';
import { addVideo, removeVideo } from '../store/playlist/actions'

const useStyles = makeStyles({
    card: {
      minWidth: 275,
    },
    dropIndicator: {
      backgroundColor: '#388e3c',
    },
  });
  

export default (state: AppState, dispatch: React.Dispatch<AnyAction>) => {

    const onDrop = useCallback((acceptedFiles:[]) => {

        acceptedFiles.forEach ( (file:File) => {
    
          const wrapper = document.createElement('div');
          const url = URL.createObjectURL(file)
          const ref:React.RefObject<ReactPlayer> = React.createRef()
    
          const durationCallback = (duration:number) => {
            dispatch( addVideo( { file, url, duration } ) )
             ReactDOM.unmountComponentAtNode(wrapper);
          }
    
          const element = <ReactPlayer ref={ref} url={url} onDuration={durationCallback}></ReactPlayer>;
          ReactDOM.render(element, wrapper);  
        })
      
      }, [dispatch])
    
    const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop})
    
    const deleteClickHander = (e:any, file:string) => {
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
      dispatch( removeVideo(file) )
      return false
    }

    const videoList = (
        <List dense>
        { state.playlist.videos.map((entry, index) => 
            <ListItem key={index} alignItems="flex-start">
            <ListItemText
                primary={entry.file.name}
                secondary={
                <React.Fragment>
                    <Typography
                    component="span"
                    variant="body2"
                    color="textPrimary"
                    >
                    duration: 
                    </Typography>
                    {moment.duration(entry.duration, 'seconds').humanize()}
                </React.Fragment>
                }
            />
            <ListItemSecondaryAction>
              <DeleteIcon onClick={e => deleteClickHander(e, entry.file.name)}/>
            </ListItemSecondaryAction>
            </ListItem>
        )}
        </List>
    )

    const classes = useStyles();

    return {
        name: "VideoFiles",
        label: "Select video files to play",
        content: (
            <Fragment>
               
                <div {...getRootProps()}>
                <input {...getInputProps()} />
                {
                    (
                        <Card className={isDragActive ? classes.dropIndicator : "" }>
                          <CardContent>
                            <Typography color="textSecondary" gutterBottom>Drop video files here (no files are ever uploaded)</Typography>
                            {videoList}
                            </CardContent>
                        </Card>
                    )
                     
                    // ? <p>Drop the files here ...</p> 
                    // : 
                }
                </div>
                {/* <Button onClick={() => dispatch(removeAll())}>remove all</Button> */}
            </Fragment>

        )    
    }
}